import React from 'react';
import PropTypes from 'prop-types';
import { ZCDTable } from '@zencity/common-ui';

/**
 * Display the pin option data table without sentiment breakdown
 */
const PinOptionDataTable = (props) => {
  const { counts } = props;
  const columns = [
    // `label` may be a React node (pin icon + name); render it via Cell so the table does not
    // coerce it to "[object Object]".
    { Header: 'Pin', accessor: 'label', Cell: ({ row }) => row.original.label },
    { Header: 'Count', accessor: 'count' },
    { Header: '%', accessor: 'percentage' },
  ];
  const total = counts.reduce((acc, count) => acc + count.subtotal, 0);
  const data = counts.map((count) => ({
    label: count.label,
    count: count.subtotal,
    percentage: ((count.subtotal / total) * 100).toFixed(2),
  }));

  return (
    <div className="pin-option-data-table">
      <ZCDTable columnArray={columns} tableData={data} />
    </div>
  );
};

PinOptionDataTable.propTypes = {
  counts: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      subtotal: PropTypes.number,
    })
  ).isRequired,
};

export default PinOptionDataTable;
